export const ISLOGOUT = "LOGOUT";
export const ISLOADINGACTIVE = "LOADINGACTIVE";
export const ISLOADINGDEACTIVE = "LOADINGDEACTIVE";
export const ISPOINT = "POINT";